define('view/controller/booking/datetime/DateInlinePickerView',['require','view/controller/booking/datetime/BaseDateView','view/controller/booking/datetime/DateInlinePickerLabelView','lib/view/BookingUrlBuilder','Config'],function (require) {

    var BaseDateView = require('view/controller/booking/datetime/BaseDateView');
    var DateInlinePickerLabelView = require('view/controller/booking/datetime/DateInlinePickerLabelView');
    var BookingUrlBuilder = require('lib/view/BookingUrlBuilder');
    var Config = require('Config');

    /**
     * Default date picker view
     *
     * @class DateInlinePickerView
     */
    return BaseDateView.extend({

        template: '#date_inline_view',

        ui: {
            'nextDateBtn': '#sb_next_date',
            'prevDateBtn': '#sb_prev_date',
            'container': '#sb_datepicker',
            'monthInput': '#sb_current_month',
            'yearInput': '#sb_current_year',
            'dateInput': '#sb_current_date'
        },
        events: {
            'change @ui.monthInput': 'changeMonth',
            'change @ui.yearInput': 'changeMonth',
            'change @ui.dateInput': 'changeDate',
            'click @ui.nextDateBtn': 'nextDate',
            'click @ui.prevDateBtn': 'prevDate'
        },
        collectionEvents: {
            'sync': 'updateDatePicker'
        },
        modelEvents: {
            'change': 'updateDatePicker'
        },
        regions: {
            'label': '#sb_label_container'
        },
        _labelView: null,
        _weekMode: false,

        updateDatePicker: function () {
            var date = null;
            if (this.model.get('start_date')) {
                date = Date.parseMysqlDate(this.model.get('start_date'));
            }

            Backbone.Wreqr.radio.vent.trigger('datepicker', 'update', {
                dates: this._dates,
                collection: this.collection,
                currentDate: date,
                timeDiff: this.getTimeDiff(),
                clientTimeZone: this.getOption('clientTimeZone')
            });
        },

        changeMonth: function () {
            this._currentYear = this.ui.yearInput.val();
            this._currentMonth = this.ui.monthInput.val();

            this.triggerMethod('changeMonth', this._currentYear, this._currentMonth);
        },

        nextDate: function () {
            var date = Date.parseMysqlDate(this.model.get('start_date'));
            date.setDate(date.getDate() + this._dates.length);

            this._updateDate(date.getMysqlDate());
        },

        prevDate: function () {
            var date = Date.parseMysqlDate(this.model.get('start_date'));
            date.setDate(date.getDate() - this._dates.length);

            this._updateDate(date.getMysqlDate());
        },

        changeDate: function () {
            this._updateDate(this.ui.dateInput.val());
        },

        _updateDate: function (date) {
            var url = BookingUrlBuilder.getInstance().buildUrl('booking_step', {
                'date': date,
                'time': null
            });

            this.model.set('start_date', date);

            if (!this.model.skipNavigationOnCalendar) {
                Backbone.history.navigate(url);
            }
        },

        serializeData: function () {
            var result = BaseDateView.prototype.serializeData.apply(this);

            result.current_date = this.model.get('start_date');
            result.current_year = this._currentYear;
            result.current_month = this._currentMonth;
            result.week_mode = this._weekMode;

            return result;
        },

        setSelectedDates: function (dates) {
            BaseDateView.prototype.setSelectedDates.apply(this, [dates]);

            var weekMode = false;
            if (this._dates.length > 1) {
                weekMode = true;
            }
            if (this._labelView) {
                this._labelView.setSelectedDates(dates);
            }

            if (weekMode !== this._weekMode) {
                this._weekMode = weekMode;
                if (!this.isDestroyed) {
                    this.render();
                }
            } else if (this.isRendered) {
                this.updateDatePicker();
            }
        },

        onRender: function () {
            this._labelView = new DateInlinePickerLabelView({
                model: this.model,
                dates: this._dates
            });
            this.label.show(this._labelView);
        },

        onDomRefresh: function () {
            var minDate = Date.parseMysqlDate(Config.getInstance().getOption('min_date'));
            var maxDate = Date.parseMysqlDate(Config.getInstance().getOption('max_date'));

            Backbone.Wreqr.radio.vent.trigger('datepicker', 'shown', {
                view: this,
                minDate: minDate,
                maxDate: maxDate
            });

            this.updateDatePicker();
        }

    });

});
